// Delivery Date & Time (Theme-only, Mini-cart)
window.DDT_CONFIG = Object.assign({
  minLeadDays: 0,
  maxDaysAhead: 14,
  disabledWeekdays: [0],
  blackoutDates: [],
  timeSlots: ["01:00–04:00 PM","04:00–06:00 PM","06:00–08:00 PM"],
  mirrorToNote: true,
  selectors: {
    drawerRoot: '[data-cart-drawer]',
    insertAfter: '[data-cart-subtotal]',
    cartRoot: 'form[action="/cart"]',
    cartInsertAfter: '.cart__footer, .cart-footer, [data-cart-footer]'
  }
}, (window.DDT_CONFIG || {}));

(function() {
  const ATTR_DATE = 'delivery_date';
  const ATTR_TIME = 'delivery_time';

  function formatYYYYMMDD(date) {
    const y = date.getFullYear();
    const m = ('0'+(date.getMonth()+1)).slice(-2);
    const d = ('0'+date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }
  function isDisabled(date, cfg) {
    const iso = formatYYYYMMDD(date);
    if ((cfg.blackoutDates||[]).includes(iso)) return true;
    if ((cfg.disabledWeekdays||[]).includes(date.getDay())) return true;
    return false;
  }
  async function fetchCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }
  async function updateCartAttributes(attrs, mirrorNoteText) {
    const payload = { attributes: attrs };
    if (mirrorNoteText) payload.note = mirrorNoteText;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    return await res.json();
  }

  function buildPicker(cart, cfg) {
    const wrap = document.createElement('div');
    wrap.className = 'ddt-picker';

    const curDate = (cart.attributes || {})[ATTR_DATE] || '';
    const curTime = (cart.attributes || {})[ATTR_TIME] || '';
    const alreadySet = !!(curDate && curTime);

    wrap.innerHTML = `
      <div class="ddt-sg-toggle">
        <label class="ddt-toggle-label">
          <input type="checkbox" id="ddt-sg-check" ${alreadySet ? 'checked' : ''} />
          <span>I'm ordering within Singapore (select delivery date &amp; time)</span>
        </label>
      </div>
      <div class="ddt-fields" style="display:${alreadySet ? 'block' : 'none'}">
        <div class="ddt-row">
          <label class="ddt-label" for="ddt-date">Delivery date</label>
          <input type="date" id="ddt-date" class="ddt-input">
        </div>
        <div class="ddt-row">
          <label class="ddt-label" for="ddt-time">Delivery time</label>
          <select id="ddt-time" class="ddt-select">
            <option value="">Select time</option>
          </select>
        </div>
        <div class="ddt-feedback" aria-live="polite"></div>
      </div>
    `;

    const sgCheck = wrap.querySelector('#ddt-sg-check');
    const fieldsDiv = wrap.querySelector('.ddt-fields');
    const dateInput = wrap.querySelector('#ddt-date');
    const timeSelect = wrap.querySelector('#ddt-time');
    const feedback = wrap.querySelector('.ddt-feedback');

    // Toggle show/hide fields
    sgCheck.addEventListener('change', async function() {
      if (this.checked) {
        fieldsDiv.style.display = 'block';
      } else {
        fieldsDiv.style.display = 'none';
        // Clear saved attributes when unchecked
        await updateCartAttributes({ [ATTR_DATE]: '', [ATTR_TIME]: '' }, '');
        feedback.textContent = '';
      }
    });

    const today = new Date();
    const min = new Date(today); min.setDate(today.getDate() + cfg.minLeadDays);
    const max = new Date(today); max.setDate(today.getDate() + cfg.maxDaysAhead);
    dateInput.min = formatYYYYMMDD(min);
    dateInput.max = formatYYYYMMDD(max);
    if (curDate) dateInput.value = curDate;

    function parseTimeRange(slot, dateStr) {
      const parts = slot.replace('–', '-').split('-');
      const start = new Date(`${dateStr} ${parts[0].trim()}`);
      const end = new Date(`${dateStr} ${parts[1].trim()}`);
      return { start, end };
    }
    function isPastSlot(slot, dateStr) {
      const now = new Date();
      const { end } = parseTimeRange(slot, dateStr);
      return now > end;
    }
    function refillSlots() {
      timeSelect.innerHTML = '<option value="">Select time</option>';
      const val = dateInput.value;
      if (!val) return;
      const d = new Date(val + 'T00:00:00');
      if (isDisabled(d, cfg)) {
        feedback.textContent = 'Date not available. Please choose another date.';
        timeSelect.disabled = true;
      } else {
        feedback.textContent = '';
        timeSelect.disabled = false;
        const todayStr = formatYYYYMMDD(new Date());
        (cfg.timeSlots||[]).forEach(ts => {
          const opt = document.createElement('option');
          opt.value = ts;
          opt.textContent = ts;
          if (val === todayStr && isPastSlot(ts, val)) opt.disabled = true;
          timeSelect.appendChild(opt);
        });
      }
    }
    dateInput.addEventListener('change', refillSlots);
    refillSlots();
    if (curTime) timeSelect.value = curTime;

    async function save() {
      const d = dateInput.value;
      const t = timeSelect.value;
      if (!d || !t) return;
      try {
        const mirror = cfg.mirrorToNote ? `Delivery: ${d} ${t}` : null;
        await updateCartAttributes({ [ATTR_DATE]: d, [ATTR_TIME]: t }, mirror);
        feedback.textContent = 'Saved ✓';
      } catch(e) {
        feedback.textContent = 'Save failed';
      }
    }
    timeSelect.addEventListener('change', save);

    return wrap;
  }

  async function mountInto(root, insertAfterSelector, cfg) {
    if (!root || root.querySelector('.ddt-picker')) return;
    const cart = await fetchCart();
    const anchor = root.querySelector(insertAfterSelector) || root;
    const picker = buildPicker(cart, cfg);
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(picker, anchor.nextSibling);
    } else {
      root.appendChild(picker);
    }
  }

  async function mountAll() {
    const cfg = window.DDT_CONFIG;
    const drawer = document.querySelector(cfg.selectors.drawerRoot);
    if (drawer) await mountInto(drawer, cfg.selectors.drawerInsertAfter, cfg);
    const cartPage = document.querySelector(cfg.selectors.cartRoot);
    if (cartPage) await mountInto(cartPage, cfg.selectors.cartInsertAfter, cfg);
  }

  document.addEventListener('DOMContentLoaded', mountAll);
  document.addEventListener('cart:refresh', mountAll);
})();